if ( typeof CollapsibleDescription !== 'function' ) {

	class CollapsibleDescription extends HTMLElement {

		constructor(){

			super();

			this.contentEl = this.querySelector('[data-js-content]');
			this.toggleEl = this.querySelector('[data-js-toggle]');
			this.labelEl = this.toggleEl ? this.toggleEl.querySelector('[data-js-toggle-label]') : null;

			if ( ! this.contentEl || ! this.toggleEl || ! this.labelEl ) {
				return;
			}

			this.readMoreLabel = this.toggleEl.getAttribute('data-read-more-label') || 'Read more';
			this.readLessLabel = this.toggleEl.getAttribute('data-read-less-label') || 'Read less';

			this.toggleEl.addEventListener('click', this.onToggle.bind(this));

			this.checkOverflow = this.checkOverflow.bind(this);
			requestAnimationFrame(this.checkOverflow);

			let resizeTimeout;
			window.addEventListener('resize', ()=>{
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(this.checkOverflow, 150);
			});

		}

		checkOverflow(){
			if ( this.classList.contains('is-expanded') ) {
				return;
			}
			const isOverflowing = this.contentEl.scrollHeight > this.contentEl.clientHeight + 2;
			this.toggleEl.hidden = ! isOverflowing;
		}

		onToggle(){
			const expanded = ! this.classList.contains('is-expanded');
			this.classList.toggle('is-expanded', expanded);
			if ( expanded ) {
				this.contentEl.removeAttribute('data-clamped');
			} else {
				this.contentEl.setAttribute('data-clamped', '');
			}
			this.labelEl.textContent = expanded ? this.readLessLabel : this.readMoreLabel;
			this.toggleEl.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		}

	}

	if ( typeof customElements.get('collapsible-description') == 'undefined' ) {
		customElements.define('collapsible-description', CollapsibleDescription);
	}

}
